import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

// hr招聘首页

Vue.use(VueRouter)

export default new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: '/webLogin',
      component:  () => import('@/views/webLogin'),
      hidden: true,
      meta: { title: '登录' }
    },
    {
      path: '/register',
      component:  () => import('@/views/webRegister.vue'),
      hidden: true,
      meta: { title: '注册' }
    },
    {
      path: '/deliver-page',
      component: () => import('@/views/delivery/deliverPage.vue'),
      name: 'basic',
      meta: { title: '二维码跳转' }
    },
    {
      path: '/delivery',
      component:  () => import('@/views/delivery/index.vue'),
      meta: { title: '简历投递主页' },
    },
    {
      path: '/deliverWarnNotice',
      component:  () => import('@/views/delivery/deliverWarnNotice.vue'),
      meta: { title: '提示' },
    },
    // 简历都用 schoolDeliverAdd ！！
    {
      path: '/schoolDeliverAddOne',
      component:  () => import('@/views/delivery/schoolDeliverAdd.vue'),
      hidden: true,
      meta: { title: '校招简历投递' },
    },
    {
      path: '/socialDeliverAddOne',
      component:  () => import('@/views/delivery/schoolDeliverAdd.vue'),
      hidden: true,
      meta: { title: '社招简历投递' },
    },
    {
      path: '/specialDeliverAddOne',
      component:  () => import('@/views/delivery/schoolDeliverAdd.vue'),
      hidden: true,
      meta: { title: '专项简历投递' },
    },
    {
      path: '/schoolDeliverEditOne',
      component:  () => import('@/views/delivery/deliverEdit.vue'),
      hidden: true,
      meta: { title: '校招简历编辑' },
    },
    {
      path: '/socialDeliverEditOne',
      component:  () => import('@/views/delivery/schoolDeliverAdd.vue'),
      hidden: true,
      meta: { title: '社招简历投递' },
    },
    {
      path: '/specialDeliverEditOne',
      component:  () => import('@/views/delivery/schoolDeliverAdd.vue'),
      hidden: true,
      meta: { title: '专项简历投递' },
    },
    {
      path: '/memberUnitsH5',
      component:  () => import('@/views/memberUnits/indexH5.vue'),
      name: 'memberUnitsH5',
      hidden: true,
      meta: { title: '成员单位' }
    },
    {
      path: '',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/webPage',
          component:  () => import('@/views/webIndexNew.vue'),
          name: 'webPage',
          meta: { title: '首页' }
        },
        {
          path: '/',
          component:  () => import('@/views/webIndexNew.vue'),
          name: 'webIndex',
          meta: { title: '首页' }
        },
        {
          path: '/notice',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/notice/index.vue'),
          name: 'notice',
          meta: { title: '公告列表' }
        },
        {
          path: '/noticeDetails',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/notice/details.vue'),
          name: 'noticeDetails',
          meta: { title: '公告明细' }
        },
        {
          path: '/memberUnits',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/memberUnits/index.vue'),
          name: 'memberUnits',
          meta: { title: '成员单位' }
        },
        {
          path: '/campusRecruitment',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/campusRecruitment/index.vue'),
          name: 'campusRecruitment',
          meta: { title: '校园招聘' }
        },
        {
          path: '/campusDetails',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/campusRecruitment/details.vue'),
          name: 'campusDetails',
          meta: { title: '校园招聘详情',noCache: true  }
        },

        {
          path: '/socialRecruitment',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/socialRecruitment/index.vue'),
          name: 'socialRecruitment',
          meta: { title: '社会招聘'  }
        },
        {
          path: '/socialDetails',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/socialRecruitment/details.vue'),
          name: 'socialDetails',
          meta: { title: '社会招聘详情',noCache: true  }
        },

        {
          path: '/specialRecruitment',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/specialRecruitment/index.vue'),
          name: 'specialRecruitment',
          meta: { title: '专项招聘' }
        },
        {
          path: '/specialDetails',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/specialRecruitment/details.vue'),
          name: 'specialDetails',
          meta: { title: '专项招聘详情',noCache: true }
        },


        {
          path: '/personnelTraining',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/personnelTraining/index.vue'),
          name: 'personnelTraining',
          meta: { title: '人才发展' }
        },
        {
          path: '/askedQuestion',
          component:  () => import(/* webpackChunkName: "user" */ '@/views/askedQuestion/index.vue'),
          name: 'askedQuestion',
          meta: { title: '常见问题' }
        },
        {
          path: '/deliveryRecords',
          name: 'deliveryRecords',
          component:  () => import('@/views/delivery/deliveryRecords.vue'),
          meta: { title: '投递记录' },
        },
      ]
    },
  ]
})

// fix buf: Avoided redundant navigation to current location: "/".
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
